<template>
  <DeviceIcon v-if="showIcon"
    :gateway-connected="!gatewayIsDisconnected"
    :connection="connection"
    :pacs="pacs"
    :pacs-hardware="pacsHardware"
    :device-meta="deviceMeta"
    :device-make="deviceMake"
    :kind="deviceKind"
  />
  <span v-else-if="showLabel">
    {{ label }}
  </span>
</template>

<script lang="ts">
import { hasDeviceProp } from '@/mixins/device'
import { getDeviceKindStatusIcon, getDeviceStatusIcon } from '@/constants/device';
import { qx_Device, qx_eDeviceKind_enum, qx_eDeviceConnectionStatus_enum } from '@/graphql/types';
import { smartIconValidator } from './helpers/smart-icon-validator'

export default {
  mixins: [hasDeviceProp],
  props: {
    type: {
      required: false,
      default: "icon",
      validator(value: string) {
        return smartIconValidator(value);
      }
    }
  },
  computed: {
    gatewayIsDisconnected() {
      const device = this.device as qx_Device;
      return !(device?.gateway?.connectionStatus || false);
    },
    connection() {
      const device = this.device as qx_Device;
      if (device?.enabled === false) {
        return 'Disabled';
      }
      return device?.connectionStatus || undefined;
    },
    isAccess() {
      const device = this.device as qx_Device;
      return device?.kind === qx_eDeviceKind_enum.Access;
    },
    pacs() {
      const device = this.device as qx_Device;
      return this.isAccess ? device?.pacsStatus : undefined;
    },
    pacsHardware() {
      const device = this.device as qx_Device;
      return this.isAccess ? device?.pacsHWUpdate : undefined;
    },
    deviceMeta() {
      const device = this.device as qx_Device;
      return device?.meta || undefined;
    },
    deviceKind() {
      const device = this.device as qx_Device;
      return device?.kind || undefined;
    },
    deviceMake() {
      const device = this.device as qx_Device;
      return device?.make || undefined;
    },
    label() {
      const { gatewayIsDisconnected, connection, pacs, pacsHardware, deviceMeta, deviceMake, deviceKind } = this;
      const status =
        getDeviceKindStatusIcon(deviceKind) ??
        getDeviceStatusIcon(
          !gatewayIsDisconnected,
          connection,
          pacs as any,
          pacsHardware as any,
          deviceMake,
          deviceMeta
        );
      return status?.tooltip || '';
    },
    showIcon() {
      return this.type === "icon";
    },
    showLabel() {
      return this.type === "label";
    }
  }
}
</script>
